import React from 'react';
import { useTheme } from '../../contexts/ThemeContext';
import './ThemeToggle.module.css';

const ThemeToggle: React.FC = () => {
  const { theme, toggleTheme } = useTheme();

  return (
    <button
      className="theme-toggle"
      onClick={toggleTheme}
      aria-label={`Preklopi na ${theme === 'light' ? 'temno' : 'svetlo'} temo`}
      title={`Preklopi na ${theme === 'light' ? 'temno' : 'svetlo'} temo`}
    >
      {theme === 'light' ? '🌙' : '☀️'}
    </button>
  );
};

export default ThemeToggle;
